import '@/lib/typedef';
import { buildQuery } from '@/lib/helper';
import client from '@/lib/http-client';

const endpoint = '/brand';

export default {
	createBrand(params, cb, errorCb) {
		const url = `${endpoint}`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	createBrandPublic(params, cb, errorCb) {
		const url = `${endpoint}/public`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
	getBrands(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}?${query}`;
		client.get(url)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
	updateBrand(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client.put(url, params)
			.then((response) => {
				cb(response.data);
			})
			.catch((e) => {
				errorCb(e);
			});
	},
	resendBrand(userId = null) {
		const itemKey = 'brandData';
		const checkBrandData = localStorage.getItem(itemKey);
		const brandData = (checkBrandData) ? JSON.parse(checkBrandData) : '';
		if (brandData) {
			if (userId) {
				brandData.user_id = userId;
				this.createBrandPublic(brandData);
			} else {
				this.createBrand(brandData);
			}
			localStorage.removeItem(itemKey);
		}
	},
};
